import { render } from "./YotpoIntegration.vue?vue&type=template&id=db1e27f6"
import script from "./YotpoIntegration.vue?vue&type=script&lang=js"
export * from "./YotpoIntegration.vue?vue&type=script&lang=js"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__